
export interface GalleryPhoto {
  id: number;
  src: string;
  alt: string;
  title: string;
  category: string;
  location: string;
  photographer: string;
  date: string;
  likes: number;
  featured: boolean;
}

export const galleryCategories = [
  'All Photos',
  'Parks & Nature',
  'Downtown',
  'Events',
  'Food & Dining',
  'Community',
  'Architecture',
];

export const galleryPhotos: GalleryPhoto[] = [
  {
    id: 1,
    src: 'https://public.readdy.ai/ai/img_res/3ab075950122f123b2d93fc4cb55e366.jpg',
    alt: 'Aerial view of Roseville California neighborhoods',
    title: 'Rose️ from Above',
    category: 'Community',
    location: 'Roseville, CA',
    photographer: 'Sarah Mitchell',
    date: 'Jan 2025',
    likes: 342,
    featured: true,
  },
  {
    id: 2,
    src: 'https://readdy.ai/api/search-image?query=Beautiful%20sunset%20over%20Miners%20Ravine%20Trail%20in%20Roseville%20California%20with%20golden%20light%20filtering%20through%20oak%20trees%2C%20peaceful%20creek%20flowing%20alongside%20paved%20walking%20path%2C%20joggers%20and%20cyclists%20enjoying%20scenic%20nature%20trail%2C%20warm%20autumn%20colors&width=800&height=1000&seq=gal-trail-002&orientation=portrait',
    alt: 'Miners Ravine Trail at sunset',
    title: 'Golden Hour on Miners Ravine',
    category: 'Parks & Nature',
    location: 'Miners Ravine Trail',
    photographer: 'David Chen',
    date: 'Dec 2024',
    likes: 518,
    featured: true,
  },
  {
    id: 3,
    src: 'https://readdy.ai/api/search-image?query=Charming%20Historic%20Old%20Town%20Roseville%20California%20with%20Victorian%20storefronts%20and%20antique%20shops%20along%20tree-lined%20street%2C%20outdoor%20cafe%20seating%20with%20string%20lights%2C%20pedestrians%20browsing%20boutiques%2C%20warm%20afternoon%20sunlight%2C%20small%20town%20American%20charm&width=800&height=600&seq=gal-oldtown-003&orientation=landscape',
    alt: 'Historic Old Town Roseville',
    title: 'Old Town Charm',
    category: 'Downtown',
    location: 'Vernon Street',
    photographer: 'Maria Lopez',
    date: 'Jan 2025',
    likes: 287,
    featured: false,
  },
  {
    id: 4,
    src: 'https://readdy.ai/api/search-image?query=Vibrant%20outdoor%20farmers%20market%20in%20California%20town%20square%20with%20colorful%20fresh%20produce%20stands%2C%20local%20artisan%20vendors%20selling%20handmade%20goods%20and%20flowers%2C%20families%20shopping%20on%20sunny%20morning%2C%20festive%20community%20atmosphere%20with%20white%20canopy%20tents&width=800&height=1000&seq=gal-market-004&orientation=portrait',
    alt: 'Roseville Farmers Market',
    title: 'Saturday Market Magic',
    category: 'Events',
    location: 'Vernon Street Town Square',
    photographer: 'James Park',
    date: 'Jan 2025',
    likes: 445,
    featured: true,
  },
  {
    id: 5,
    src: 'https://readdy.ai/api/search-image?query=Delicious%20gourmet%20brunch%20spread%20at%20trendy%20California%20restaurant%20with%20avocado%20toast%2C%20fresh%20berry%20pancakes%2C%20artisan%20coffee%20latte%20art%2C%20beautiful%20plating%20on%20rustic%20wooden%20table%2C%20natural%20light%20from%20large%20windows%2C%20modern%20cafe%20interior&width=800&height=600&seq=gal-food-005&orientation=landscape',
    alt: 'Brunch at local Roseville restaurant',
    title: 'Brunch Culture',
    category: 'Food & Dining',
    // Properly escaped apostrophe using double quotes
    location: "The Monk's Cellar",
    photographer: 'Emily Watson',
    date: 'Dec 2024',
    likes: 392,
    featured: false,
  },
  {
    id: 6,
    src: 'https://readdy.ai/api/search-image?query=Beautiful%20Maidu%20Regional%20Park%20in%20Roseville%20California%20with%20expansive%20green%20meadows%20and%20mature%20oak%20trees%2C%20children%20playing%20on%20modern%20playground%20equipment%2C%20families%20having%20picnic%20on%20sunny%20day%2C%20scenic%20walking%20paths%20and%20blue%20sky&width=800&height=600&seq=gal-maidu-006&orientation=landscape',
    alt: 'Maidu Regional Park',
    title: 'Family Day at Maidu Park',
    category: 'Parks & Nature',
    location: 'Maidu Regional Park',
    photographer: 'Tom Richards',
    date: 'Nov 2024',
    likes: 267,
    featured: false,
  },
  {
    id: 7,
    src: 'https://readdy.ai/api/search-image?query=Spectacular%20Fourth%20of%20July%20fireworks%20display%20over%20California%20park%20at%20night%2C%20colorful%20red%20white%20and%20blue%20fireworks%20explosions%20lighting%20up%20dark%20sky%2C%20crowd%20watching%20from%20park%20lawn%2C%20patriotic%20celebration%20atmosphere%20with%20reflections%20on%20lake&width=800&height=1000&seq=gal-fireworks-007&orientation=portrait',
    alt: 'Fourth of July fireworks in Roseville',
    title: 'Independence Day Spectacular',
    category: 'Events',
    location: 'Johnson-Springview Park',
    photographer: 'Alex Turner',
    date: 'Jul 2024',
    likes: 631,
    featured: true,
  },
  {
    id: 8,
    src: 'https://readdy.ai/api/search-image?query=Modern%20Westfield%20Galleria%20shopping%20mall%20exterior%20at%20dusk%20with%20elegant%20architecture%20and%20ambient%20lighting%2C%20palm%20trees%20and%20landscaped%20walkways%2C%20shoppers%20entering%20upscale%20retail%20destination%2C%20contemporary%20commercial%20building%20design%20in%20California&width=800&height=600&seq=gal-galleria-008&orientation=landscape',
    alt: 'Westfield Galleria at Roseville',
    title: 'Galleria at Dusk',
    category: 'Architecture',
    location: 'Westfield Galleria',
    photographer: 'Nina Patel',
    date: 'Dec 2024',
    likes: 198,
    featured: false,
  },
  {
    id: 9,
    src: 'https://readdy.ai/api/search-image?query=Community%20volunteers%20planting%20trees%20in%20California%20park%20on%20sunny%20day%2C%20diverse%20group%20of%20people%20working%20together%20in%20garden%2C%20green%20sustainability%20project%20happy%20neighbors%20collaborating%20outdoors%20community%20service%20event&width=800&height=600&seq=gal-volunteer-009&orientation=landscape',
    alt: 'Community tree planting event',
    title: 'Growing Together',
    category: 'Community',
    location: 'Woodcreek Oaks',
    photographer: 'Rachel Kim',
    date: 'Oct 2024',
    likes: 356,
    featured: false,
  },
  {
    id: 10,
    src: 'https://readdy.ai/api/search-image?query=Peaceful%20lake%20at%20sunset%20in%20California%20community%20park%20with%20ducks%20swimming%20on%20calm%20water%2C%20beautiful%20reflection%20of%20orange%20and%20pink%20sky%2C%20willow%20trees%20along%20shoreline%2C%20park%20bench%20in%20foreground%20serene%20natural%20landscape&width=800&height=1000&seq=gal-lake-010&orientation=portrait',
    alt: 'Mahany Park lake at sunset',
    title: 'Mahany Lake Reflections',
    category: 'Parks & Nature',
    location: 'Mahany Park',
    photographer: 'David Chen',
    date: 'Sep 2024',
    likes: 489,
    featured: true,
  },
  {
    id: 11,
    src: 'https://readdy.ai/api/search-image?query=Outdoor%20summer%20concert%20in%20California%20town%20square%20at%20evening%2C%20live%20band%20performing%20on%20stage%20with%20colorful%20lights%20crowd%20of%20people%20dancing%20and%20enjoying%20music%20food%20trucks%20in%20background%20festive%20community%20celebration%20atmosphere%20with%20string%20lights&width=800&height=600&seq=gal-concert-011&orientation=landscape',
    alt: 'Summer concert series in Roseville',
    title: 'Music Under the Stars',
    category: 'Events',
    location: 'Vernon Street Town Square',
    photographer: 'Sarah Mitchell',
    date: 'Aug 2024',
    likes: 412,
    featured: false,
  },
  {
    id: 12,
    src: 'https://readdy.ai/api/search-image?query=Artisan%20pizza%20being%20pulled%20from%20wood-fired%20oven%20at%20trendy%20California%20restaurant%2C%20melted%20mozzarella%20and%20fresh%20basil%20on%20crispy%20crust%20chef%20hands%20with%20pizza%20peel%20warm%20rustic%20kitchen%20atmosphere%20with%20brick%20oven%20authentic%20Italian%20dining%20experience&width=800&height=600&seq=gal-pizza-012&orientation=landscape',
    alt: 'Wood-fired pizza at local restaurant',
    title: 'Fresh from the Oven',
    category: 'Food & Dining',
    location: 'Old Town Pizza',
    photographer: 'Emily Watson',
    date: 'Nov 2024',
    likes: 324,
    featured: false,
  },
  {
    id: 13,
    src: 'https://readdy.ai/api/search-image?query=Beautiful%20California%20craftsman%20style%20home%20with%20manicured%20front%20yard%20garden%2C%20blooming%20roses%20and%20lavender%20along%20stone%20pathway%2C%20mature%20shade%20trees%20warm%20afternoon%20sunlight%20charming%20residential%20neighborhood%20architecture&width=800&height=600&seq=gal-home-013&orientation=landscape',
    alt: 'Charming Roseville neighborhood home',
    title: 'Neighborhood Charm',
    category: 'Architecture',
    location: 'Historic District',
    photographer: 'Tom Richards',
    date: 'Oct 2024',
    likes: 215,
    featured: false,
  },
  {
    id: 14,
    src: 'https://readdy.ai/api/search-image?query=Children%20playing%20in%20splash%20pad%20water%20fountain%20at%20modern%20California%20park%20on%20hot%20summer%20day%2C%20colorful%20water%20jets%20and%20sprays%20kids%20laughing%20and%20running%20through%20water%20features%20families%20watching%20from%20shaded%20benches%20bright%20sunny%20day&width=800&height=1000&seq=gal-splash-014&orientation=portrait',
    alt: 'Kids at Roseville splash pad',
    title: 'Summer Splash Fun',
    category: 'Community',
    location: 'Johnson-Springview Park',
    photographer: 'Maria Lopez',
    date: 'Jul 2024',
    likes: 378,
    featured: false,
  },
  {
    id: 15,
    src: 'https://readdy.ai/api/search-image?query=Scenic%20cycling%20path%20through%20rolling%20green%20hills%20with%20wildflowers%20in%20Northern%20California%2C%20cyclist%20riding%20on%20smooth%20paved%20trail%20panoramic%20view%20of%20Sacramento%20Valley%20clear%20blue%20sky%20with%20wispy%20clouds%20outdoor%20recreation%20adventure&width=800&height=600&seq=gal-bike-015&orientation=landscape',
    alt: 'Cycling trail near Roseville',
    title: 'Ride the Foothills',
    category: 'Parks & Nature',
    location: 'Dry Creek Trail',
    photographer: 'Alex Turner',
    date: 'May 2024',
    likes: 298,
    featured: false,
  },
  {
    id: 16,
    src: 'https://readdy.ai/api/search-image?query=Cozy%20craft%20beer%20taproom%20interior%20with%20industrial%20chic%20decor%2C%20flight%20of%20amber%20and%20golden%20craft%20beers%20on%20wooden%20paddle%20exposed%20brick%20walls%20and%20Edison%20bulb%20lighting%20friends%20toasting%20at%20bar%20counter%20trendy%20California%20brewery%20atmosphere&width=800&height=600&seq=gal-beer-016&orientation=landscape',
    alt: 'Craft beer tasting in Roseville',
    title: 'Craft Beer Culture',
    category: 'Food & Dining',
    location: 'Roseville Brewing Co.',
    photographer: 'Nina Patel',
    date: 'Nov 2024',
    likes: 267,
    featured: false,
  },
];
